import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

/**
 * The single TanStack Router instance shared across the app. The route tree
 * is regenerated by `@tanstack/router-plugin/vite` on every dev / build.
 */
export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
